import React from "react";
import { Link, useParams } from "react-router-dom";

export default function AdminTopClientNav() {
  const { recruiterUsername, clientUsername } = useParams();

  const clusterDashboardRoute = `/recruiters/${recruiterUsername}/clients/${clientUsername}`;
  const ordersRoute = `/recruiters/${recruiterUsername}/clients/${clientUsername}/orders`;
  const analyticsRoute = `/recruiters/${recruiterUsername}/clients/${clientUsername}/analytics`;
  const notificationsRoute = `/recruiters/${recruiterUsername}/clients/${clientUsername}/notifications`;
  const settingsRoute = `/recruiters/${recruiterUsername}/clients/${clientUsername}/settings`;
  const createOrderRoute = `/recruiters/${recruiterUsername}/clients/${clientUsername}/create-order`;

  const navStyle = "block text-blue-700 hover:text-blue-800 mr-6 text-sm";

  return (
    <div
      className="z-10 fixed top-[60px] left-[250px] h-[50px] bg-white border-b border-b-gray-300 px-4 py-2 flex justify-between"
      style={{ width: "calc(100% - 250px)" }}
    >
      <ul className="flex items-center">
        <Link className={navStyle} to={clusterDashboardRoute}>
          Client Dashboard
        </Link>
        <Link className={navStyle} to={ordersRoute}>
          Orders
        </Link>
        <Link className={navStyle} to={analyticsRoute}>
          Analytics
        </Link>
        <Link className={navStyle} to={notificationsRoute}>
          Notifications
        </Link>
        <Link className={navStyle} to={settingsRoute}>
          Settings
        </Link>
      </ul>
      <ul className="flex items-center">
        <Link className={navStyle} to={createOrderRoute}>
          New Order
        </Link>
      </ul>
    </div>
  );
}
